import { 
    BRANDKIT_INITIATE_ICONS_UPLOAD, BRANDKIT_INVALIDATE_ICONS_UPLOAD_ERROR, BRANDKIT_UPDATE_ICONS_UPLOAD_PROGRESS, 
    BRANDKIT_UPLOAD_ICONS_REQUEST, BRANDKIT_UPLOADING_ICONS_SUCCEEDED, BRANDKIT_UPLOADING_ICONS_FAILED,
    BRANDKIT_SEARCH_ICONS_REQUEST, BRANDKIT_SEARCHING_ICONS_SUCCEEDED, BRANDKIT_SEARCHING_ICONS_FAILED, 
    BRANDKIT_DELETE_ICONS_REQUEST, BRANDKIT_DELETING_ICONS_SUCCEEDED, BRANDKIT_DELETING_ICONS_FAILED, 
    BRANDKIT_INVALIDATE_ICONS_LIBRARY, BRANDKIT_INVALIDATE_ICONS_DELETE_ERROR
  } from 'constants/actionTypes';
  
  import { call, put, takeEvery } from 'redux-saga/effects';
  import axios from 'axios';
  import { createAction } from 'redux-actions';
  import buildUrl from 'build-url';
  
  const apiUrl = process.env.REACT_APP_CLEVERSTORY_API_URL;
  const BRANDKIT_ICONS_URL = `${apiUrl}/api/2.0/media`;
    
  /**
   * Initiate Icons upload
  */
  export const initiateBrandKitIconsUpload = createAction(BRANDKIT_INITIATE_ICONS_UPLOAD, (request) => {
    return request;
  });
  
  export const updateBrandKitIconsUploadProgress = createAction(BRANDKIT_UPDATE_ICONS_UPLOAD_PROGRESS, (id, progress) => {
    return {id, progress};
  });
  
  export const uploadBrandKitIcons = createAction(BRANDKIT_UPLOAD_ICONS_REQUEST, (id, request, callback) => {
    return {id, request, callback};
  })
  
  export const uploadingBrandKitIconsSucceeded = createAction(BRANDKIT_UPLOADING_ICONS_SUCCEEDED, (id, response) => {
    return {id, response};
  })
  
  export const uploadingBrandKitIconsFailed = createAction(BRANDKIT_UPLOADING_ICONS_FAILED, (id, error) => {
    return {id, error};
  })
  
  function* uploadBrandKitIconsSaga(action) {
    const {id, request, callback} = action.payload;
  
    const uploadBrandKitIconsAPI = () => {
      return axios.post(BRANDKIT_ICONS_URL, request).then(response => response.data);
    }
  
    try {
      const response = yield call(uploadBrandKitIconsAPI);
      if (response) {
        yield put(uploadingBrandKitIconsSucceeded(id, response));
        if(callback) {
          callback(response);
        }
      }
    } catch (error) {
      yield put(uploadingBrandKitIconsFailed(id, error));
    }
  }
  
  
  /**
   * Search Icons
   * 
  */
  export const searchBrandKitIcons = createAction(BRANDKIT_SEARCH_ICONS_REQUEST, (request) => {
    return request;
  });
  
  const searchingBrandKitIconsSucceeded = createAction(BRANDKIT_SEARCHING_ICONS_SUCCEEDED, (request, response) => {
    return {request, response};
  })
  
  const searchingBrandKitIconsFailed = createAction(BRANDKIT_SEARCHING_ICONS_FAILED, (request, error) => {
    return { request, error };
  });
  
  function* searchBrandKitIconsSaga(action) {
    const request = action.payload;
  
    const fetchAllBrandKitIconsAPI = () => {
      return axios.post(`${BRANDKIT_ICONS_URL}/search`, request).then(response => response.data);
    }
  
    try {
      const response = yield call(fetchAllBrandKitIconsAPI);
      yield put(searchingBrandKitIconsSucceeded(request, response));
    } catch (error) {
      yield put(searchingBrandKitIconsFailed(error));
    }
  }
  
  /**
   * Delete Icons
   * 
  */
  export const deleteBrandKitIcons = createAction(BRANDKIT_DELETE_ICONS_REQUEST, (ids) => {
    return ids;
  });
  
  const deleteingBrandKitIconsSucceeded = createAction(BRANDKIT_DELETING_ICONS_SUCCEEDED, (ids, response) => {
    return { ids, response };
  })
  
  const deleteingBrandKitIconsFailed = createAction(BRANDKIT_DELETING_ICONS_FAILED, (ids, error) => {
    return { ids, error };
  });
  
  function* deleteBrandKitIconsSaga(action) {
    const ids = action.payload;
  
    let url = buildUrl(BRANDKIT_ICONS_URL);
  
    const deleteBrandKitIconsAPI = () => {
      return axios.delete(url, {data: ids}).then(response => response.data);
    }
  
    try {
      const response = yield call(deleteBrandKitIconsAPI);
      yield put(deleteingBrandKitIconsSucceeded(ids, response));
    } catch (error) {
      yield put(deleteingBrandKitIconsFailed(ids, error));
    }
  }
  
  /**
   * Invalidate Upload Error
  */
  export const invalidateBrandKitIconsUploadError = createAction(BRANDKIT_INVALIDATE_ICONS_UPLOAD_ERROR);
  
  /**
   * Invalidate Icons Library
   * 
  */
  export const invalidateBrandKitIconsLibrary = createAction(BRANDKIT_INVALIDATE_ICONS_LIBRARY);
  
  
  /**
   * Delete Error
   */
  
  export const invalidateBrandKitIconsDeleteError=createAction(BRANDKIT_INVALIDATE_ICONS_DELETE_ERROR);
  
  export default function* brandKitIconsSaga() {
    yield takeEvery(BRANDKIT_UPLOAD_ICONS_REQUEST, uploadBrandKitIconsSaga);
    yield takeEvery(BRANDKIT_SEARCH_ICONS_REQUEST, searchBrandKitIconsSaga);
    yield takeEvery(BRANDKIT_DELETE_ICONS_REQUEST, deleteBrandKitIconsSaga);
  }